export default __webpack_public_path__ + "static/media/address_icon.cf300ca1.svg";